import snakeToCamel from "../helpers/snakeToCamel";

const FormMixin = {
    data: () => ({
        validationError: null,
        validationErrors: {},
    }),
    methods: {
        checkForm() {
            this.validationError = null;
            this.validateForm();
            if (Object.keys(this.validationErrors).length) {
                this.validationError = this.$t('FIX_ALL_ERRORS')
                this.scrollToTop();
                return false;
            }
            return true;
        },
        validateFormMixin() {
            this.validationErrors = {};
            this.$el.querySelectorAll(".form-group.required .form-control, .form-group.required .custom-select").forEach(element => {
                if (!element.value) {
                    this.validationErrors[snakeToCamel(element.id)] = this.$t('REQUIRED_FIELD');
                }
            });
        },
        validateForm() {
            this.validateFormMixin();
        },
        showError(err){
            if (err.graphQLErrors && err.graphQLErrors.length && err.graphQLErrors[0].extensions &&
              err.graphQLErrors[0].extensions.code && err.graphQLErrors[0].extensions.code === "BAD_USER_INPUT") {
                this.validationErrors = err.graphQLErrors[0].extensions.exception.validationErrors;
                this.validationError = err.graphQLErrors[0].message;
            } else if (err.networkError) {
                this.validationError = this.$t('CONNECTION_TO_THE_SERVER');
            } else {
                this.validationError = this.$t('UNKNOWN_ERROR');
            }

            this.scrollToTop();
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        disableForm() {
            this.$el.querySelectorAll(".form-control, .custom-select").forEach(element => {
                element.disabled = true;
            });
        },
        activeForm() {
            this.$el.querySelectorAll(".form-control, .custom-select").forEach(element => {
                element.disabled = false;
            });
        }
    }
};

export default FormMixin
